import { InjectionToken } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ISbStory, ISbStoryData, StoryblokBridgeV2 } from '@storyblok/js';
import { Observable } from 'rxjs';
import { StoryblokStoriesQuery } from './lib/storyblok-cache-tags';
import { StoryblokLink } from './storyblok/storyblok-types';

export interface PicflowStoryblok {
  getStories(
    options: StoryblokStoriesQuery,
    route?: ActivatedRouteSnapshot
  ): Observable<{ stories: ISbStoryData[]; total: number }>;
  getStory(slug: string, route?: ActivatedRouteSnapshot): Observable<ISbStory['data'] | false>;
  // loadComponents(story: ISbStoryData): Promise<void>;
  prepLoadComponents(story: ISbStoryData): Promise<string[]>;
  resolveRelationshipsFromStory(story: ISbStoryData, route?: ActivatedRouteSnapshot): Promise<ISbStoryData<unknown>[]>;
  updates$: Observable<{
    story: ISbStoryData;
  }>;
  getUrlLink(link: StoryblokLink): string;
  getLinkName(link: StoryblokLink): string | undefined;
  getStoryTitle(story: ISbStoryData): string;
  getStoryDescription(story: ISbStoryData): string;
  getUniqueComponentsList(route: ActivatedRouteSnapshot, _path?: string): Observable<Set<string>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolveRelationships(route: ActivatedRouteSnapshot, _path?: string): Observable<any[]>;
  storyblokInstance: StoryblokBridgeV2;
}

export const PICFLOW_STORYBLOK = new InjectionToken<PicflowStoryblok>('storyblok');
